'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _picq = require('./picq.component');

var _picq2 = _interopRequireDefault(_picq);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var picqModule = _angular2.default.module('picq', [_angularUiRouter2.default]).component('picq', _picq2.default);

exports.default = picqModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/picq/picq.js